// import { SelectItem } from "primeng/api";

export interface VisaoItem /* extends SelectItem */ {
  label: string;
  type: string;
  tooltip?: string;
  icon?: string;
}

export interface Total {
  total: number;
}
